import { userAccountStore } from "@/store/loginStore";
import { authJwt } from "./auth";
// import router from "@/router";
import axios from "axios";

var devConsole = false

const apis = ["https://devshehan.runasp.net", "http://localhost:44351", "http://localhost:26926"]
const bots = ["", "http://192.168.35.155:5000"];
const agents = ["", "http://localhost:5678"];

let api = null;
let bot = null;
let agent = null;

const isHostedOnline = window.location.hostname !== "localhost";
if(isHostedOnline){
    api = apis[0];
    bot = bots[0];
    agent = agents[0];
}else{
    api = apis[1];
    bot = bots[1];
    agent = agents[1];
}

export async function PostRequest(path, data = null, root = '', auth = '') {
    const userData = userAccountStore();
    let baseUrl;
    let BaseResponce = {
        data: null,
        status: 0
    }

    var isAuth = null;
    if (auth === 'supper-user') {
        isAuth = authJwt(auth)
        
        if (isAuth) {
            devConsole && console.log(auth, isAuth, "supper user auth done")
            
        } else {
            console.log(auth, isAuth, "auth faild")

            if (window.location.pathname != '/dashboard/login') {
                userData.supperUserLogout();
            }
        }
    }else if(auth === 'user' ){
        isAuth = userData.userToken ? true : false;

        if (isAuth) {
            devConsole && console.log(auth, isAuth, "auth done");
            
        } else {
            console.log(auth, isAuth, "auth faild");
            userData.userLogout(null);
        }
    }

    if (root == '') {
        baseUrl = api;
    } else if (root == 'ai_chat') {
        baseUrl = bot;
    }else if (root == 'agent'){
        baseUrl = agent
    }

    let token = null;
    if (auth.toLowerCase() === 'user') {
        token = `Bearer ${userData.userToken}`;
    } else if (auth.toLowerCase() === 'supper-user') {
        token = `Bearer ${userData.supperUserToken}`;
    } else {
        token = '';
    }

    try {
        var responce = null;
        if (userData.supperUserToken != null && userData.supperUserToken !== '' && auth == 'supper-user') {
            responce = await axios.post(`${baseUrl}${path}`, data, {
                headers: {
                    Authorization: token,
                    'Content-Type': 'application/json'
                }
            });
        }else if (userData.userToken != null && userData.userToken !== '' && auth == 'user') {
            responce = await axios.post(`${baseUrl}${path}`, data, {
                headers: {
                    Authorization: token,
                    'Content-Type': 'application/json'
                }
            });
        } else {
            responce = await axios.post(`${baseUrl}${path}`, data);
        }

        if (responce?.data && responce?.data?.statusCode == 200) {
            BaseResponce.data = responce.data.data;
            BaseResponce.status = responce.data.statusCode;
        } else {
            BaseResponce.data = responce;
            BaseResponce.status = 204;
        }
    } catch (error) {
        BaseResponce.data = error;
        BaseResponce.status = 400;
    }
    return BaseResponce
}

export function ConnectionPath() {
    return {
        api: api,
        bot: bot
    }

}


// axios.post('https://your-api-url/api/submit', data, {
//   headers: {
//     Authorization: `Bearer ${token}`,
//     'Content-Type': 'application/json'
//   }
// })
// .then(response => {
//   console.log('Success:', response.data);
// })
// .catch(error => {
//   console.error('Error:', error.response?.data || error.message);
// });

